import { Box } from '@mui/material';
import { ChallengeCard } from '../../components/ChallengeCard/ChallengeCard';
import { Loading } from '../../components/Loading/Loading';
import { Copy } from '../../copy/Copy';
import { flexCenterSx } from '../../styles/Global.style';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { marginTop8Sx, paddingBottom24Sx } from './Challenge.style';
import { useCommunity } from '../../hooks/useCommunity/useCommunity';

export const Challenge = () => {
  const { leaderboard, isLeaderboardLoading } = useCommunity();

  return (
    <PageContainer title={Copy.generate('Global.challenge')}>
      {!isLeaderboardLoading ? (
        <Box
          component="div"
          sx={{ ...flexCenterSx, ...marginTop8Sx, ...paddingBottom24Sx }}
        >
          <ChallengeCard leaderboard={leaderboard} />
        </Box>
      ) : (
        <Loading />
      )}
    </PageContainer>
  );
};
